'use strict';

var CalibrationAnalysisPanelDirective = function CalibrationAnalysisPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/calibration-analysis-panel.html'),
    controller: 'CalibrationAnalysisPanelController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', scope.onCalibrationRowSelectionChange);
      scope.$on('online-logit-calibration:back-to-calibration-screen', scope.displayAndRefreshCalibrationAnalysis);
      scope.$on('gridExpand:online-logit-calibration-review', scope.toggleToolbar);
    }
  };
};
CalibrationAnalysisPanelDirective.$inject = [];
module.exports = CalibrationAnalysisPanelDirective;